import { Link } from 'react-router-dom';
import './BotaoContato.css';

function BotaoContato({ texto, rota }) {
  return (
    <a 
      href={rota}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="btn botao-contato mb-2"
    >
      {texto}
    </a>
  );
}

export default BotaoContato;
